class TrackingMode {
  modesNames = {
    finding_mode: "Finding Mode",
    area_tracking: "Adaptive tracking",
    standby: "Standby",
    emergency: "Emergency",
    dynamic: "Dynamic",
    low_power: "Low power",
    ble_only: "BlueTooth only",
    motion_triggered: "Motion triggered",
    lte_only: "LTE only",
    enhanced_mode: "Enhanced mode",
  };
  getModeInfo(tracking: string) {
    return this.modesNames[tracking] || "---";
  }
}

const trackingModes = new TrackingMode();
export default trackingModes;
